import { render } from "./DailyPush.vue?vue&type=template&id=240ba11e&ts=true"
import script from "./DailyPush.vue?vue&type=script&lang=ts"
export * from "./DailyPush.vue?vue&type=script&lang=ts"

import "./DailyPush.vue?vue&type=style&index=0&id=240ba11e&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__